<template>
    <div
        class="Skeleton"
        :class="[
            {
                'with-background': withBackground,
            },
        ]"
    >
        <div v-if="showCards" class="skeleton-cards-grid">
            <div v-for="i in cardCount" :key="`card-${i}`" class="skeleton-card"></div>
        </div>

        <div v-if="showToolbar" class="skeleton-toolbar"></div>

        <div v-if="showTable" class="skeleton-table"></div>
    </div>
</template>
<script>
export default {
    name: 'Skeleton',
    props: {
        withBackground: {
            type: Boolean,
            default: true,
        },
        showCards: {
            type: Boolean,
            default: true,
        },
        cardCount: {
            type: Number,
            default: 5,
        },
        showToolbar: {
            type: Boolean,
            default: true,
        },
        showTable: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.Skeleton {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: fixed;
    z-index: 101;
    top: 0px;
    left: var(--nav-width, 230px);
    width: calc(100vw - var(--nav-width, 230px));
    height: 100vh;
    transition:
        left 0.4s ease-out,
        width 0.4s ease-out;

    &.with-background {
        background: var(--color-bg);
    }

    @media (max-width: $breakpoint-tablet-portrait) {
        padding: 20px 16px calc(20px + env(safe-area-inset-bottom)) 16px;
        left: 0px;
        width: 100vw;
        height: calc(100vh - 85px);
        top: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .skeleton-cards-grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 16px;
        margin-bottom: 8px;

        @media (max-width: 1400px) {
            grid-template-columns: repeat(3, 1fr);
        }

        @media (max-width: $breakpoint-tablet-portrait) {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
            margin-bottom: 4px;
        }

        .skeleton-card {
            height: 85px;
            background-color: rgb(217, 217, 231);
            border-radius: 4px;
            position: relative;
            overflow: hidden;

            @media (max-width: $breakpoint-tablet-portrait) {
                height: 75px;
            }

            &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                transform: translateX(-100%);
                background-image: linear-gradient(
                    90deg,
                    transparent,
                    rgba(255, 255, 255, 0.4),
                    rgba(255, 255, 255, 0.6),
                    rgba(255, 255, 255, 0.4),
                    transparent
                );
                animation: shimmer 1.5s ease-in-out infinite;
                content: '';
            }
        }
    }

    .skeleton-toolbar {
        height: 120px;
        background-color: rgb(217, 217, 231);
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        margin-bottom: 8px;

        @media (max-width: $breakpoint-tablet-portrait) {
            height: 180px;
            margin-bottom: 4px;
        }

        &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.4),
                rgba(255, 255, 255, 0.6),
                rgba(255, 255, 255, 0.4),
                transparent
            );
            animation: shimmer 1.5s ease-in-out infinite;
            content: '';
        }
    }

    .skeleton-table {
        flex: 1;
        background-color: rgb(217, 217, 231);
        border-radius: 4px;
        position: relative;
        overflow: hidden;
        min-height: 400px;

        @media (max-width: $breakpoint-tablet-portrait) {
            min-height: 300px;
        }

        &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(
                90deg,
                transparent,
                rgba(255, 255, 255, 0.4),
                rgba(255, 255, 255, 0.6),
                rgba(255, 255, 255, 0.4),
                transparent
            );
            animation: shimmer 1.5s ease-in-out infinite;
            content: '';
        }
    }

    @keyframes shimmer {
        0% {
            transform: translateX(-100%);
        }
        100% {
            transform: translateX(100%);
        }
    }
}
</style>
